import { useEffect } from 'react'
import ReactPixel from 'react-facebook-pixel'

interface UsePixelProps {
    page: string
}
export function usePixel({ page }: UsePixelProps) {
    useEffect(() => {
        ReactPixel.track('PageView', {
            content_name: page,
            content_category: 'page',
        })
    }, [page])
}
